import { Component } from "@builder.io/sdk";

export const missionVisionPurposeCiIonConfig: Component = {
  name: "Mission Vision Purpose CI-ION",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "mission-vision-purpose",
      friendlyName: "Section ID",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "title",
      type: "string",
      defaultValue: "Mission, Vision, and Purpose",
      friendlyName: "Section Title",
      helperText:
        "Title for the section (visually hidden but used for screen readers and accessibility)",
      required: true,
    },
    {
      name: "mission",
      type: "object",
      friendlyName: "Mission Statement",
      defaultValue: {
        title: "Our Mission",
        text: "Empowering the next generation of nursing assistants with digital mastery and hands-on expertise for compassionate healthcare. Our mission is to cultivate a community of passionate lifelong learners who are dedicated to making a difference in the world.",
      },
      subFields: [
        {
          name: "title",
          type: "string",
          friendlyName: "Mission Title",
          helperText: "Heading for the mission statement (e.g., 'Our Mission')",
          required: true,
        },
        {
          name: "text",
          type: "longText",
          friendlyName: "Mission Text",
          helperText:
            "The mission statement describing the organization's core purpose and goals",
          required: true,
        },
      ],
      helperText:
        "Define your organization's mission - what you do and why you do it",
      required: true,
    },
    {
      name: "vision",
      type: "object",
      friendlyName: "Vision Statement",
      defaultValue: {
        title: "Our Vision",
        text: "Empowering healthcare leaders. We believe that education is more than a stepping stone to a career, it's a lifelong pursuit. We provide students with the tools and knowledge needed to become leaders in their field.",
      },
      subFields: [
        {
          name: "title",
          type: "string",
          friendlyName: "Vision Title",
          helperText: "Heading for the vision statement (e.g., 'Our Vision')",
          required: true,
        },
        {
          name: "text",
          type: "longText",
          friendlyName: "Vision Text",
          helperText:
            "The vision statement describing where you see the organization in the future",
          required: true,
        },
      ],
      helperText:
        "Describe your organization's vision - what you aspire to achieve in the future",
      required: true,
    },
    {
      name: "purpose",
      type: "object",
      friendlyName: "Purpose Statement",
      defaultValue: {
        title: "Our Purpose",
        text: "At Care Indeed Institute of Nursing, we firmly believe that compassion combined with excellence can reshape healthcare. We see immense potential in you and are here to help you drive that change.",
      },
      subFields: [
        {
          name: "title",
          type: "string",
          friendlyName: "Purpose Title",
          helperText: "Heading for the purpose statement (e.g., 'Our Purpose')",
          required: true,
        },
        {
          name: "text",
          type: "longText",
          friendlyName: "Purpose Text",
          helperText:
            "The purpose statement explaining why your organization exists and its impact",
          required: true,
        },
      ],
      helperText:
        "Explain your organization's purpose - the deeper reason for existence and impact on society",
      required: true,
    },
    {
      name: "layout",
      type: "string",
      friendlyName: "Layout Style",
      defaultValue: "stacked",
      enum: ["stacked", "grid"],
      helperText:
        "Choose layout: stacked (vertical arrangement) or grid (side-by-side cards)",
      advanced: true,
    },
    {
      name: "backgroundColor",
      type: "string",
      friendlyName: "Background Color",
      defaultValue: "secondary-100",
      enum: ["white", "primary-100", "secondary-100"],
      helperText:
        "Background color for the section: white, primary-100 (Light Primary), or secondary-100 (Light Secondary)",
      advanced: true,
    },
    {
      name: "textAlignment",
      type: "string",
      friendlyName: "Text Alignment",
      defaultValue: "left",
      enum: ["left", "center", "right"],
      helperText: "Alignment of text content within each statement",
      advanced: true,
    },
  ],
};
